import { createReducer } from '@reduxjs/toolkit'
import { resetPagination, changePage } from '../actions/PaginationAction'

export interface PaginationState {
  page?: number
  size?: number
}

const initialPagination = {
  page: 0,
  size: 15
}

const paginationReducer = createReducer(initialPagination, (builder) => {
  builder
    .addCase(changePage, (state, action) => {
      state.page = action.payload
    })
    .addCase(resetPagination, (state) => {
      state.page = 0
      state.size = initialPagination.size
    })
})

export { paginationReducer, initialPagination }
